import React from "react";
import ScrollAnimation from "react-animate-on-scroll";
import { Container, Row, Col } from "reactstrap";
import Button from "reactstrap/lib/Button";
import S2 from "./svgs/s2";
import S5 from "./svgs/s5";
import S8 from "./svgs/s8";
import S1 from "./svgs/s1";
import S3 from "./svgs/s3";

function TextGrid() {
  let pageHeader = React.createRef();
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;

  const content = [
    {
      title: "Banks Reimagined: The Shift from Legacy to Digital-First Financial Powerhouses:",
      description:
        "With traditional banks reimagining their operating models, fintech disruptors driving innovation, and regulatory frameworks fostering seamless digital adoption, Qatar is at the forefront of the next wave of financial evolution",
      image: <S2 />,
    },
    {
      title: "Next-Gen Banking: AI & the Future of Customer Experience",
      description:
        "With the rise of AI-powered banking, cloud-native infrastructure, and real-time analytics, Qatar’s financial sector is embracing next-generation technologies to enhance agility and customer experience. ",
      image: <S3 />,
    },
    {
      title: "A Cashless Qatar: The Future of Payments & Digital Transactions:",
      description:
        "As Qatar accelerates towards a cashless economy, real-time payments, digital wallets, and CBDCs are paving the way for a frictionless financial ecosystem. This session will explore the impact of blockchain, tokenization, and open banking APIs in shaping the future of transactions.",
      image: <S8 />,
    },
  ];
  return (
    <>
      <div
        style={{
          background: "transparent",
        }}
        className="section"
        data-parallax={true}
        ref={pageHeader}
      >
        <Container>
          <Row>
            <Col lg={12}>
              <h1
                className=" text-700 pb-0 text-white mt-0 text-uppercase"
                style={{ fontSize: size ? "2.5rem" : "1.5rem" }}
              >
                <b>
                  Building a Digital-First Financial Future:
                  <br /> Fintech’s Role in Qatar’s Vision 2030
                </b>
              </h1>
            </Col>
            <Col lg={12} md={12} sm={12} className="">
              <h5
                className="text-400 text-white text-justify"
                style={{
                  lineHeight: "30px",
                  color: "#010011",
                  textTransform: "none",
                }}
              >
                <br />
                <br />
                Qatar is fast-tracking its digital finance revolution, with bold regulatory reforms,
                fintech investments, and AI-driven innovations shaping its financial future. As the
                nation advances toward Vision 2030, Finnovex Qatar 2026 returns as the leading
                platform for industry pioneers, decision-makers, and disruptors to drive the next
                wave of financial transformation. Join us on November 18 in Doha to explore how open
                banking, digital payments, embedded finance, and cybersecurity are redefining
                Qatar’s fintech landscape—fueling a smarter, more inclusive, and future-ready
                economy.
              </h5>
            </Col>
            {content.map((s, index) => (
              <Col lg={6} className="mt-5 pr-0">
                <ScrollAnimation
                  animateIn={"fadeInUp"}
                  animateOnce={true}
                  duration={0.5 + index / 8}
                >
                  <div className="pt-4 px-2 stat-div mb-2" style={{ minHeight: 200 }}>
                    <div className="container-fluid row pr-0">
                      <Col className="align-self-center" xs={3}>
                        {s.image}
                      </Col>
                      <Col>
                        <h3
                          style={{
                            color: "#fff",
                            fontSize: size ? "18px" : "14px",
                          }}
                          className="text-700 mt-0"
                        >
                          {s.title}
                        </h3>
                        <h3
                          style={{
                            color: "#fff",
                            fontSize: size ? "16px" : "12px",
                          }}
                          className="text-400 mt-0"
                        >
                          {s.description}
                        </h3>
                      </Col>
                    </div>
                  </div>
                </ScrollAnimation>
              </Col>
            ))}
            <Col xs={12}>
              <Button className="px-3 py-2  my-2 rounded-0" color="primary" href="/about">
                <p className="m-0 text-700" style={{ color: "#fff" }}>
                  Know More
                </p>
              </Button>
            </Col>
            <br />
            <br />
          </Row>
        </Container>
      </div>
    </>
  );
}

export default TextGrid;
